import { Box, styled } from '@mui/material';
import { GridCompact6 } from 'components/shared/Grid/Grid.components';

export const EntitySectionContainer = styled(GridCompact6)({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0
});

export const SelectedEntitiesList = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  minHeight: 0,
  paddingRight: theme.spacing(1),
  overflowY: 'auto',
  maxHeight: '35vh'
}));
